import { useEffect } from "react"
import DailyCalendarHeader from "./daily-calendar-header"
import DailyCalendar from "./daily-calendar"
import useGetDailyCalendar from "@/modules/study/queries/use-get-daily-calendar"
import { useDailyCalendarEvents } from "../../stores/use-daily-calendar-events"

interface DailyCalendarLayoutProps {
  onClickActivitiesExceeded: () => void
  mainHeaderIsSticky?: boolean
}

export default function DailyCalendarLayout({
  onClickActivitiesExceeded,
  mainHeaderIsSticky = false,
}: DailyCalendarLayoutProps) {
  const { setAllEvents } = useDailyCalendarEvents()
  const { isError, data, isPending } = useGetDailyCalendar()

  useEffect(() => {
    if (data && data.length > 0) {
      setAllEvents(data)
    }
  }, [data, setAllEvents])

  if (isError) {
    return <div>Algo salió mal...</div>
  }

  return (
    <div className="relative mr-5 flex size-full flex-col gap-5 overflow-hidden rounded-lg bg-neutral-100 px-4 py-8">
      {isPending && (
        <div className="absolute inset-0 z-30 flex items-start justify-center bg-gray-50 bg-opacity-60 pt-56 after:absolute after:h-16 after:w-16 after:animate-spin after:rounded-full after:border-4 after:border-primary after:border-t-transparent after:content-['']"></div>
      )}

      <DailyCalendarHeader mainHeaderIsSticky={mainHeaderIsSticky} />

      <div className="size-full overflow-hidden">
        <DailyCalendar onClickActivitiesExceeded={onClickActivitiesExceeded} />
      </div>
    </div>
  )
}
